import React from "react";
import styles from "./App.module.scss";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";


function App(): JSX.Element {
  return (
      <div className={styles.root}>
        <div className={styles.wrapper}>
          <BrowserRouter>
            <div className={styles.page}>
              <Routes />
            </div>
          </BrowserRouter>
        </div>
      </div>
  );
}

export default App;